module.exports = __webpack_public_path__ + "static/ff-saleslanding-image-body-voices-marc-markstein-ibouKITXBFM-unsplash.a8a19e01.jpg";